import assetStatusService from "../../../../services/assetService/assetStatusService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETSTATUSES } from "../../../../utils/constants";
import { AssetStatusInterface } from "../../../../models/AssetModel/AssetStatus";

interface AddAssetStatusesContext {
  previousAssetStatuses: AssetStatusInterface[];
}

const useAddAssetStatuses = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    AssetStatusInterface,
    Error,
    AssetStatusInterface,
    AddAssetStatusesContext
  >({
    mutationFn: assetStatusService.Save,

    onMutate: () => {
      const previousAssetStatuses =
        queryClient.getQueryData<AssetStatusInterface[]>([
          CACHE_KEY_ASSETSTATUSES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousAssetStatuses };
    },

    onSuccess: (savedAssetStatus) => {
      queryClient.setQueryData<AssetStatusInterface[]>(
        [
          CACHE_KEY_ASSETSTATUSES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (assetStatuses) =>
          assetStatuses
            ? [savedAssetStatus, ...assetStatuses]
            : [savedAssetStatus]
      );
    },

    onError: (error, newAssetStatus, context) => {
      if (!context) return;

      queryClient.setQueryData<AssetStatusInterface[]>(
        [
          CACHE_KEY_ASSETSTATUSES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousAssetStatuses
      );
    },
  });
};

export default useAddAssetStatuses;
